// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'interact';

export const Component = () => (
  <path d='M24.569 1.006V.001H14.75v1.005h8.812V9.82h.958V1.006h.048Zm-13.027 9.866h8.094V9.866h-9.77v9.77h1.006v-8.094l12.596 12.644.67-.719-12.596-12.596ZM9.818 0H0v9.818h1.005V1.005h8.813V0ZM1.005 23.563v-8.812H0v9.818h1.005v-.048h8.813v-.958H1.005Z' />
);

export const viewBox = '0 0 25 25';
